import { Card, Flex, Form, Switch, Tag, Typography } from "antd"
import React, { useState } from "react"

import { PasswordSecurityPasswords } from "./PasswordSecurityPasswords.tsx"

const { Text } = Typography

export function PasswordSecurityFormSection() {
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(true)

  return (
    <div>
      {/* Password Management */}
      <PasswordSecurityPasswords />

      {/* Two-Factor Authentication */}
      <div className="flex items-center justify-between mb-2 pl-[3px]">
        <Text className="font-medium">Two-Factor Authentication</Text>
        <Tag className={"mr-0"} color={"green"}>
          Enabled
        </Tag>
      </div>
      <Form.Item>
        <Card size={"small"}>
          <Flex justify={"space-between"} align={"center"}>
            <Flex vertical flex={1}>
              <Text>Add an extra layer of security to your account</Text>
              <Text type={"secondary"}>Using authentication app</Text>
            </Flex>
            <Switch
              disabled
              checked={twoFactorEnabled}
              onChange={setTwoFactorEnabled}
            />
          </Flex>
        </Card>
      </Form.Item>
      {/*/!* Login Activity *!/*/}
      {/*<div>*/}
      {/*  <Text className="font-medium block mb-3">Login Activity</Text>*/}
      {/*  <div className="space-y-2 bg-gray-50 p-3 rounded-md">*/}
      {/*    <div className="flex justify-between text-sm">*/}
      {/*      <Text className="text-gray-600">Last Login</Text>*/}
      {/*      <Text className="font-medium">2 hours ago</Text>*/}
      {/*    </div>*/}
      {/*    <div className="flex justify-between text-sm">*/}
      {/*      <Text className="text-gray-600">IP Address</Text>*/}
      {/*      <Text className="font-medium">192.168.1.100</Text>*/}
      {/*    </div>*/}
      {/*    <div className="flex justify-between text-sm">*/}
      {/*      <Text className="text-gray-600">Location</Text>*/}
      {/*      <Text className="font-medium">New York, NY</Text>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <Button type="link" className="text-blue-600 px-0 mt-2 text-sm">*/}
      {/*    View all login activity*/}
      {/*  </Button>*/}
      {/*</div>*/}
    </div>
  )
}
